import React, { useEffect, useState } from 'react';
import Messages from '../components/Messages.js';
import { getEmails } from '../helper/apiHelper.js';
import db from '../helper/dbHelper.js';
import { useLoading } from '../context/LoadingContext';
import { useDispatch, useSelector } from "react-redux";

function Spam() {
    const [user, setUser] = useState({
        name: '',
        wallet: {
            wallet: {
                address: '',
                privateKey: ''
            }
        }
    });
    const pageType = 'draft';
    const [messages, setMessages] = useState([]);
    const { showLoader, hideLoader } = useLoading();
    const dispatch = useDispatch();
    const refreshMessage = useSelector((state) => state.refreshMessage);
    const triggerPaninate = useSelector((state) => state.triggerPaninate);


    useEffect(() => {
        const getData = async () => {
            await getEmailData(user.wallet.username);
        }
        getData();
    }, [refreshMessage])

    useEffect(() => {
        const userdata = JSON.parse(localStorage.getItem('user'));
        setUser(userdata);
        getEmailData(userdata.wallet.username);
    }, [])

    const getEmailData = async (email, offset) => {
        if (!email) return;
        showLoader();
        const data = await getEmails(email, pageType, null, offset);
        const fData = await formatedData(data.res);
        setMessages(fData);
        hideLoader();
    }


    const reRender = async () => {
        dispatch({ type: "REFRESH_MESSAGE", payload: !refreshMessage })
    }

    const formatedData = async (data) => {
        const formattedResult = await Promise.all(data.map(async (email) => {
            const emailDetails = JSON.parse(email.email_details);
            const sender = ([emailDetails.recipient, emailDetails.cc, emailDetails.bcc].filter(Boolean).join(", ")).split(',')[0];
            return {
                created_at: email.created_at,
                receivedDate: email.created_at,
                id: email.id,
                encryptedData: emailDetails.message,
                decryptedData: emailDetails.message,
                sender: sender,
                senderName: sender,
                subject: emailDetails.subject,
                emailDetails: email.email_details,
                is_sent: false
            };
        }));
        return formattedResult;
    }

    const getPaginatedData = async () => {
        const data = await getEmails(user.wallet.username, pageType, null, messages.length);
        const fData = await formatedData(data.res);
        setMessages([...messages, ...fData]);
    }

    useEffect(() => {
        if (messages.length > 0) {
            getPaginatedData();
        }
    }, [triggerPaninate])

    return (
        <>
            <Messages messages={messages} reRender={reRender} pageType={pageType} />
        </>
    );
}

export default Spam;
